export default __webpack_public_path__ + "static/media/4-desk.b6cf676c.jpg";